import { render, staticRenderFns } from "./SgRegistration.vue?vue&type=template&id=90e43504&"
import script from "./SgRegistration.vue?vue&type=script&lang=js&"
export * from "./SgRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports